"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputContentContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ContentTextInput_1 = require("../../atoms/ContentTextInput/ContentTextInput");
const InputContentContainer = ({ content, editable = false }) => {
    return ((0, jsx_runtime_1.jsxs)("section", { className: "dxp-ctm-section", children: [(0, jsx_runtime_1.jsx)("div", { className: "dxp-ctm-section__header", children: (0, jsx_runtime_1.jsx)("h3", { children: "Original" }) }), (0, jsx_runtime_1.jsx)(ContentTextInput_1.ContentTextInput, { content: content, editable: editable })] }));
};
exports.InputContentContainer = InputContentContainer;
